import {
  Image,
  ImageBackground,
  ImageSourcePropType,
  Pressable,
  StyleSheet,
  Text,
  View,
  useWindowDimensions,
} from 'react-native';
import theme from 'theme';

import Logo from 'assets/logo_on.png';

import NewGradientButton from 'components/Button/NewGradienteButton';

type StepsProps = {
  step: number;
  title: string;
  description: string;
  ButtonTitle: string;
  bgImage: ImageSourcePropType;
  handleNextSlide: () => void;
  handleNexttoLogin: () => void;
};

const OnboardingItem: React.FC<StepsProps> = ({
  step,
  title,
  description,
  bgImage,
  ButtonTitle,
  handleNextSlide,
  handleNexttoLogin,
}) => {
  const { width } = useWindowDimensions();

  return (
    <ImageBackground source={bgImage}>
      <View style={[styles.container, { width }]}>
        <Image source={Logo} style={styles.logo} />
        <View style={styles.contentContainer}>
          <View style={styles.textContainer}>
            <Text style={styles.titleText}>{title}</Text>
            <Text style={styles.descriptionText}>{description}</Text>
          </View>

          <View style={[styles.buttonContainer, { width: width < 720 ? '100%' : '50%' }]}>
            <NewGradientButton height={54}>
              <Text
                style={styles.buttonText}
                onPress={step === 3 ? handleNexttoLogin : handleNextSlide}>
                {ButtonTitle.toUpperCase()}
              </Text>
            </NewGradientButton>

            <Pressable
              style={[styles.skipButton, { opacity: step === 3 ? 0 : 1 }]}
              onPress={handleNexttoLogin}>
              <Text style={styles.skipText}>Pular</Text>
            </Pressable>
          </View>
        </View>
      </View>
    </ImageBackground>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingVertical: 60,
    paddingHorizontal: 10,
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100%',
  },
  logo: {
    width: 150,
    height: 40,
    resizeMode: 'contain',
  },
  contentContainer: {
    padding: 10,
    width: '100%',
    alignItems: 'center',
    gap: 32,
  },
  textContainer: {
    alignItems: 'center',
    gap: 16,
  },
  titleText: {
    fontSize: 24,
    lineHeight: 32,
    color: 'white',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  descriptionText: {
    maxWidth: '80%',
    fontSize: 16,
    lineHeight: 24,
    textAlign: 'center',
    color: 'white',
    fontWeight: 'bold',
  },
  buttonContainer: {
    alignItems: 'center',
    gap: 16,
  },
  buttonText: {
    width: '100%',
    textAlign: 'center',
    fontWeight: 'bold',
    color: '#070d31',
    fontSize: 14,
  },
  skipButton: {
    marginTop: 8,
    padding: 10,
    width: 96,
  },
  skipText: {
    textAlign: 'center',
    fontSize: 14,
    color: '#7A8CFF',
    textDecorationLine: 'underline',
    fontFamily: theme.fonts.inter.bold,
  },
});

export default OnboardingItem;
